enum VehicleStatusType {
  Unknown = 0,
  Initial = 1,
  AdditionalUserChoice = 2,
  AdditionalUserRecommend = 4,
  PartExchange = 8
}

export default VehicleStatusType;
